import ReactDOM from 'react-dom';

const calendarRoot = document.getElementById('modal-root');

const CalendarContainer = props => {
    return ReactDOM.createPortal(props.children, calendarRoot);
};

export default CalendarContainer;
